import { t } from 'i18next';
import { sortBy } from 'lodash';
import { useState } from 'react';
import { Box } from 'reflexbox';

import type { DevelopmentPlanUserFragment, Goal as IGoal } from '@treams/treams-network';
import { AddIcon, Button, Skeleton } from '@treams/treams-ui';

import EditGoalModal from './EditGoalModal';
import Goal from './Goal';

export default Skeleton(
	function Goals({ user, onSave }: { user: DevelopmentPlanUserFragment; onSave: () => void }) {
		const [showEditGoalModal, setShowEditGoalModal] = useState(false);
		const [goalToEdit, setGoalToEdit] = useState<IGoal | null>(null);

		const handleClose = () => {
			setShowEditGoalModal(false);
			setGoalToEdit(null);
		};

		const handleSave = () => {
			handleClose();
			onSave();
			setGoalToEdit(null);
		};

		const handleEdit = (goal: IGoal) => {
			setShowEditGoalModal(true);
			setGoalToEdit(goal);
		};

		return (
			<>
				{sortBy(user.activeGoals, 'createdAt').map((goal) => (
					<Goal key={goal.id} goal={goal as IGoal} onEdit={handleEdit} />
				))}
				{user.completedGoals.map((goal) => (
					<Goal key={goal.id} goal={goal as IGoal} onEdit={handleEdit} />
				))}

				<Box display="inline-block">
					<Button
						onClick={() => setShowEditGoalModal(true)}
						icon={<AddIcon />}
						title={t('developmentPlan.index.addButton')}
						type="secondary"
					/>
				</Box>
				{showEditGoalModal && (
					<EditGoalModal goal={goalToEdit} user={user} onClose={handleClose} onSave={handleSave} />
				)}
			</>
		);
	},
	function GoalsSkeleton() {},
);
